module.exports = __webpack_public_path__ + "img/557271.b5fe8eaa.png";